import { TooltipProps } from '.';
import React from 'react';

// This object should contain a mock value for each required prop of this component
export const requiredProps: TooltipProps = {
  children: <div />,
};

// This array should contain an object only for tests you wish to run on all compliance tests
const sharedTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
    } as TooltipProps,
  },
];

export const testkitTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
      content: 'hello',
    } as TooltipProps,
  },
];

export const ssrTests = [...sharedTests];

export const a11yTests = [...sharedTests];
